import React from 'react';
import { Timeline } from '@mui/lab';
import { styled } from '@mui/material/styles';

import Breakline from 'components/molecules/breakline/Breakline';

import HightowerBorn from './timeline-items/HightowerBorn'
import SeaFound from './timeline-items/SeaFound';
import FalcoBorn from './timeline-items/FalcoBorn';
import RobustelliInaugurate from './timeline-items/RobustelliInaugurate';
import ChandlerJoin from './timeline-items/ChandlerJoin';
import FalcoJoin from './timeline-items/FalcoJoin';
import BtmcFound from './timeline-items/BtmcFound';
import FalcoDead from './timeline-items/FalcoDead';
import HotelHightowerOpen from './timeline-items/HotelHightowerOpen';
import MysticManorOpen from './timeline-items/MysticManorOpen';
import OceaneerLab from './timeline-items/OceaneerLab';
import SeaMeeting from './timeline-items/SeaMeeting';
import KongoExpedition from './timeline-items/KongoExpedition';
import HightowerDisappear from './timeline-items/HightowerDisappear';
import FalcoExhibition from './timeline-items/FalcoExhibition';
import AdventurersClubFound from './timeline-items/AdventurersClubFound';
import JungleNavigationCoFound from './timeline-items/JungleNavigationCoFound';
import JungleCruiseStart from './timeline-items/JungleCruiseStart';
import SkipperCanteenOpen from './timeline-items/SkipperCanteenOpen';
import HangarBarOpen from './timeline-items/HangarBarOpen'
import AbracadabarOpen from './timeline-items/AbracadabarOpen'
import PleasureDeparture from './timeline-items/PleasureDeparture'
import AdventurersClubClose from './timeline-items/AdventurersClubClose'
import AdventurersClubReopen from './timeline-items/AdventurersClubReopen'
import AuntysBeachHouseOpen from './timeline-items/AuntysBeachHouseOpen'
import DavinciBorn from './timeline-items/DaVinciBorn'
import NewCrest from './timeline-items/NewCrest';
import HightowerAndCo from './timeline-items/HightowerAndCo';
import HightowerIndustries from './timeline-items/HightowerIndustries';
import HightowerCorporation from './timeline-items/HightowerCorporation';
import ShinjiTakahashi from './timeline-items/ShinjiTakahashi';

class SeaTimeline extends React.Component {
  render() {
    return (
      <CustomStyle>
        <Breakline
          title='S.E.A.創設期'
          range='1400年 〜 1700年'
          description={
            '大航海時代はヨーロッパ人たちが航海・探検を盛んに行っていた時代であり、' +
            '同時に自然科学の研究が盛んであった時代でもある。' +
            'そんな大航海時代にS.E.A.が設立され、探検家・研究者たちがお互いに知識を共有し合った。'
          }
          img='https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2022/01/CIMG0593.jpg'
        />
        <Timeline>
          <DavinciBorn/>
          <SeaFound/>
        </Timeline>

        <Breakline
            title='S.E.A.再興期'
            range='1800年 〜 1890年'
            description={
              '創設からおよそ300年間、S.E.A.は記録に残るような目立った活動は行ってこなかった。' +
              'しかし19世紀、S.E.A.は活動の理念を一新し、世界中から歴史的に価値のある美術品や財宝を集め調査するようになる。'
            }
            img='https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/sea_main.jpg'
          />
        <Timeline>
          <NewCrest/>
          <FalcoBorn/>
          <RobustelliInaugurate/>
          <ChandlerJoin/>
          <HightowerBorn/>
          <HightowerAndCo/>
          <HightowerIndustries/>
          <BtmcFound/>
          <FalcoJoin/>
          <FalcoDead/>
        </Timeline>

        <Breakline
          title='S.E.A.繁栄期'
          range='1891年 〜 1959年'
          description={
            '20世紀頃、S.E.A.が最も繁栄していたと思われる時期。' +
            '代表的なメンバーの多くがこの時期にS.E.A.に加入している。'
          }
          img='https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2016/09/CiOPjj3UUAArasV-300x242.jpg'
        />
        <Timeline>
          <HotelHightowerOpen/>
          <MysticManorOpen/>
          <OceaneerLab/>
          <KongoExpedition/>
          <SeaMeeting/>
          <HightowerDisappear/>
          <FalcoExhibition/>
          <AdventurersClubFound/>
          <JungleNavigationCoFound/>
          <JungleCruiseStart/>
          <SkipperCanteenOpen/>
          <HangarBarOpen/>
          <AbracadabarOpen/>
          <PleasureDeparture/>
          <AdventurersClubClose/>
        </Timeline>

        <Breakline
          title='現代'
          range='1960年 〜 現在'
          description={
            '16世紀に始まったS.E.A.は時代と主に変化し続け、現代でも活動を続けている。'
          }
          img='https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2022/01/FEpSz9UXMAUF2Tm.jpg'
        />
        <Timeline>
          <HightowerCorporation/>
          <AdventurersClubReopen/>
          <AuntysBeachHouseOpen/>
          <ShinjiTakahashi/>
        </Timeline>
      </CustomStyle>
    );
  }
}

const CustomStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    '& .MuiTimelineOppositeContent-root': {
      flex: 0.3,
      padding: '6px',
    },
  },
}));

export default SeaTimeline;
